import { FormField, RadioBox, RadioGroup } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  isRequired: boolean;
  onChange: (isRequired: boolean) => void;
};

export const CustomFieldIsRequiredFormField = ({
  isRequired,
  onChange,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <FormField
      label={t('customFields.creation.typeLabel')}
      description={t('customFields.creation.typeDescription')}
    >
      <RadioGroup
        aria-labelledby="isRequired"
        name="isRequired"
        value={isRequired ? 'mandatory' : 'optional'}
        onChange={(event) => {
          onChange(event.target.value === 'mandatory');
        }}
      >
        <RadioBox
          value="mandatory"
          label={t('customFields.creation.typeOptionMandatory')}
        />
        <RadioBox
          value="optional"
          label={t('customFields.creation.typeOptionOptional')}
        />
      </RadioGroup>
    </FormField>
  );
};
